// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
  transform: scale(0.9);
  transform-origin: top left;
  width: 111.111%; /* 1/0.9 * 100% */
  min-height: 111.111%; /* 1/0.9 * 100% */
  margin: 0 auto;
}

/* If you have height issues with some containers, you might need this */
html, body {
  overflow: hidden;
}
.app {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 111vh;
  overflow: hidden;
}
.side-bar-layout {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
}
.top-bar-layout {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.top-bar{
  position: relative;
  height: 8%;
  width: 100%;
}
.content{
  width: 80%;
  height: 100%;
}

.app-wrapper{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 100vh;
}

.p-chip{
  border-radius: 3px;
  font-size: 0.85rem;
  padding: 0 15px;
}

.Food{
  background-color: #FFF0E4;
}
.Other{
  background-color: #E4E5FF;
}

/* Add these media queries at the bottom of the file */
@media screen and (max-width: 768px) {
  .app {
    flex-direction: column;
  }
  
  .side-bar-layout {
    flex-direction: column;
  }
  
  .content {
    width: 100% !important;
    height: calc(100% - 120px);
    overflow-y: auto;
  }
  
  /* Hide sidebar on mobile */
  .nav-bar {
    display: none !important;
  }
  
  /* Adjust top bar for mobile */
  .top-bar {
    height: 60px;
  }
}

/* Add styles for mobile navigation */
.mobile-nav {
  display: none;
}

@media screen and (max-width: 768px) {
  .mobile-nav {
    display: flex;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 60px;
    background-color: white;
    border-top: 1px solid #ECECEC;
    justify-content: space-around;
    align-items: center;
    z-index: 1000;
  }
  
  .mobile-nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px;
    cursor: pointer;
  }
  
  .mobile-nav-item img {
    width: 24px;
    height: 24px;
    margin-bottom: 4px;
  }
  
  .mobile-nav-item span {
    font-size: 12px;
    color: #211A1A;
  }
  
  .mobile-nav-item.selected {
    color: #4F4BFF;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe,EAAE,iBAAiB;EAClC,oBAAoB,EAAE,iBAAiB;EACvC,cAAc;AAChB;;AAEA,wEAAwE;AACxE;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,sDAAsD;AACtD;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA,2BAA2B;EAC3B;IACE,wBAAwB;EAC1B;;EAEA,8BAA8B;EAC9B;IACE,YAAY;EACd;AACF;;AAEA,qCAAqC;AACrC;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,6BAA6B;IAC7B,6BAA6B;IAC7B,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["#root {\n  transform: scale(0.9);\n  transform-origin: top left;\n  width: 111.111%; /* 1/0.9 * 100% */\n  min-height: 111.111%; /* 1/0.9 * 100% */\n  margin: 0 auto;\n}\n\n/* If you have height issues with some containers, you might need this */\nhtml, body {\n  overflow: hidden;\n}\n.app {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: 111vh;\n  overflow: hidden;\n}\n.side-bar-layout {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n}\n.top-bar-layout {\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.top-bar{\n  position: relative;\n  height: 8%;\n  width: 100%;\n}\n.content{\n  width: 80%;\n  height: 100%;\n}\n\n.app-wrapper{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.p-chip{\n  border-radius: 3px;\n  font-size: 0.85rem;\n  padding: 0 15px;\n}\n\n.Food{\n  background-color: #FFF0E4;\n}\n.Other{\n  background-color: #E4E5FF;\n}\n\n/* Add these media queries at the bottom of the file */\n@media screen and (max-width: 768px) {\n  .app {\n    flex-direction: column;\n  }\n  \n  .side-bar-layout {\n    flex-direction: column;\n  }\n  \n  .content {\n    width: 100% !important;\n    height: calc(100% - 120px);\n    overflow-y: auto;\n  }\n  \n  /* Hide sidebar on mobile */\n  .nav-bar {\n    display: none !important;\n  }\n  \n  /* Adjust top bar for mobile */\n  .top-bar {\n    height: 60px;\n  }\n}\n\n/* Add styles for mobile navigation */\n.mobile-nav {\n  display: none;\n}\n\n@media screen and (max-width: 768px) {\n  .mobile-nav {\n    display: flex;\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    height: 60px;\n    background-color: white;\n    border-top: 1px solid #ECECEC;\n    justify-content: space-around;\n    align-items: center;\n    z-index: 1000;\n  }\n  \n  .mobile-nav-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 8px;\n    cursor: pointer;\n  }\n  \n  .mobile-nav-item img {\n    width: 24px;\n    height: 24px;\n    margin-bottom: 4px;\n  }\n  \n  .mobile-nav-item span {\n    font-size: 12px;\n    color: #211A1A;\n  }\n  \n  .mobile-nav-item.selected {\n    color: #4F4BFF;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
